import { SwitchProps as AntdSwitchProps } from 'antd';
import { StyledSwitch } from './Switch.styles';

type SwitchProps = AntdSwitchProps;

export const Switch = (props: SwitchProps): JSX.Element => <StyledSwitch {...props} />;
